import { gql } from '@apollo/client/core';

export const updateUserProfileContactInfo = gql`
  mutation updateUserProfileContactInfo($where: UserProfileWhereUniqueInput!, $data: UserProfileUpdateInput!) {
    social {
      updateUserProfile(where: $where, data: $data) {
        code
        userProfileData {
          onboardingProperties {
            contactsInfo
          }
        }
        adviseMessage {
          description
        }
      }
    }
  }
`;
